import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { login, logoutStatic } from "../../../StateManagement/authSlice";
import { useDispatch, useSelector } from "react-redux";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../Api/Api";
import SweetAlert from "../SweetAlert/SweetAlert";
import { getProvince } from "../../../StateManagement/ProvinceSlice";
import { InputFormat } from "../FormOptions/InputFormat";
import { DropDownFormat } from "../FormOptions/DropDownFormat";
import { fetchData } from "../../../Cpanel/Components/Utilities";
import AvatarImg from "../../../Assets/images/avatar.png"
const defaultValues = {
  BirthDay: new Date(),
  CityId: "",
  ProvinceId: "",
  family: "",
  name: "",
  sex: "",
};

export const PersonalInformation = ({ onNext }) => {
  const [avatarSrc, setAvatarSrc] = useState("");
  const [Logo, setLogo] = useState("");

  const [checkLogin, setCheckLogin] = useState(null);
  const [cityList, setCityList] = useState([]);
  const [ProvinceList, setProvinceList] = useState([]);
  const province = useSelector((state) => state?.province?.province);

  const {
    handleSubmit,
    watch,
    reset,
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues });

  useEffect(() => {
    dispatch(getProvince());
    const mapOptions = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.provinceid,
        label: item.provincename,
      }));
    };
    const data = mapOptions(province);
    setProvinceList(data);
  }, []);

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("guid", bodyFormData, handleApiResponse);
  }, []);

  const handleApiResponse = (data) => {
    setCheckLogin(data?.UserId);

    setUserLogo(data?.userinfo?.pic);
    setAvatarSrc(data?.userinfo?.pic);
    reset({
      ...defaultValues,
      ...data?.userinfo,
      BirthDay: new Date(data?.userinfo?.BirthDay) || new Date(),
    });
  };

  useEffect(() => {
    if (checkLogin === "0") {
      dispatch(logoutStatic());
      navigate("/");
    }
  }, [checkLogin]);

  const dispatch = useDispatch();
  const [userLogo, setUserLogo] = useState(null);
  const navigate = useNavigate();
  const handleUpload = async (w, h, sednFile) => {
    if (!sednFile) {
      return;
    }
    const image = new Image();
    image.src = sednFile;
    const cWith = w;
    const cHeight = h;
    let percentWidth = 0;
    let percentHeight = 0;
    image.onload = async () => {
      const canvas = document.createElement("canvas");
      const orginalWidht = image.naturalWidth;
      const orginalHeight = image.naturalHeight;
      if (cWith === 0 || cHeight === 0) {
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
      } else {
        percentWidth = cWith / orginalWidht;
        percentHeight = cHeight / orginalHeight;
        const percent =
          percentHeight < percentWidth ? percentHeight : percentWidth;
        canvas.width = image.naturalWidth * percent;
        canvas.height = image.naturalHeight * percent;
      }

      canvas
        .getContext("2d")
        .drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(async (blob) => {
        const myImage = new File([blob], "my-new-name.webp", {
          type: blob.type,
        });
        const formData = new FormData();
        formData.append("file", myImage);
        formData.append("guid", Cookies.get("guid"));
        try {
          const response = await axios.post(BASE_URL, formData, {
            headers: {
              "Content-type": "application/octet-stream",
              Accept: "application/json",
              cmd: "avatar",
            },
            onUploadProgress: (progressEvent) => {
              document.getElementById("progressbar").classList.remove("d-none");
              document.getElementById("fileProgress").value =
                progressEvent.loaded;

              // .item('value')= progressEvent.loaded
              document.getElementById("fileProgress").max = progressEvent.total;

              document.getElementById("fileProgress").content =
                ((progressEvent.loaded * 100) / progressEvent.total).toFixed(
                  0
                ) + "%";
              if (progressEvent.loaded === progressEvent.total) {
                document.getElementById("progressbar").classList.add("d-none");
              }
            },
          });
          if (response.status === 200) {
            const data = await response.data;
            setCheckLogin(data?.UserId);
          } else {
            console.error(`API request failed with status: ${response.status}`);
          }
        } catch (error) {
          console.error("Error while fetching menu data:", error);
        }
      }, "image/webp");
    };
  };

  const onSubmit = async (data) => {
    const bodyFormData = new FormData();

    bodyFormData.append("step", 1);
    bodyFormData.append("name", data?.name);
    bodyFormData.append("family", data?.family);
    bodyFormData.append("sex", data?.sex);
    bodyFormData.append("BirthDay", new Date(data?.BirthDay));
    bodyFormData.append("provinceId", data?.ProvinceId);
    bodyFormData.append("cityId", data?.CityId);
    bodyFormData.append("address", "");
    bodyFormData.append("guid", Cookies.get("guid"));
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "updateprofile",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
          dispatch(logoutStatic());
          navigate("/");
        }
        const data = responseGlobal.data;
        SweetAlert({
          title: "",
          text: "اطلاعات اولیه با موفقیت ذخیره شد.",
          type: "success",
        });
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };
  const handleSendImage = (image) => {
    const width = 800;
    const height = 800;
    handleUpload(width, height, image);
  };
  const handleLogout = () => {
    dispatch(logoutStatic());
  };

  useEffect(() => {
    const fetchData = async () => {
      const bodyFormData = new FormData();
      bodyFormData.append("provinceId", watch("ProvinceId"));
      try {
        const response = await axios.post(BASE_URL, bodyFormData, {
          headers: {
            "Content-type": "multipart/form-data",
            Accept: "application/json",
            cmd: "city",
          },
        });
        if (response.status === 200) {
          const data = await response.data;

          return data?.dt;
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      } catch (error) {
        throw error;
      }
    };
    if (!watch("ProvinceId")) {
      setCityList([]);
      return;
    }
    fetchData().then((value) => {
      const mapOptions = (apiResponse) => {
        return apiResponse?.map((item) => ({
          value: item.cityid,
          label: item.cityname,
        }));
      };
      const data = mapOptions(value);
      setCityList(data);
      console.log(data);
    });
  }, [watch("ProvinceId")]);

  return (
    <div dir="rtl" className="mx-5">
      <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
        <Row className=" d-flex justify-content-center align-items-center ">
          <Col className="px-5 col-12 col-lg-6">
            <div className="col-12 text-center m-auto ">
              <img
                id="avatar"
                className="avatar"
                onClick={() => document.getElementById("fileInput").click()}
                alt="برای ارسال عکس کلیک کنید"
                src={!Logo ? avatarSrc ? `https://api.taab30.com${avatarSrc}`: AvatarImg :Logo}
              />
              <input
                type="file"
                id="fileInput"
                className="d-none"
                onChange={(e) => {
                  if (e.target.files.length > 0) {
                    setLogo(URL.createObjectURL(e.target.files[0]));
                    handleSendImage(URL.createObjectURL(e.target.files[0]));
                  }
                  // setLogo((prevState) => (e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : prevState));
                  setTimeout(() => {
                    // document.getElementById('btn-upload').click()
                  }, 1);
                  //
                }}
              />
              <button
                id="btn-upload"
                className="d-none"
                onClick={() => handleSendImage()}
              >
                click
              </button>
              <div id="progressbar" className="d-none text-center">
                <p className="text-center">در حال بارگزاری فایل</p>
                <progress content="10" id="fileProgress"></progress>
              </div>
              <br />
              <br />
            </div>
          </Col>
        </Row>
        <Row>
          <Col className=" col-12 col-lg-6">
            <InputFormat
              control={control}
              name="name"
              type={"text"}
              label="نام"
              errors={errors}
            />
          </Col>
          <Col className=" col-12 col-lg-6">
            <InputFormat
              control={control}
              name="family"
              type={"text"}
              label="نام خانوادگی"
              errors={errors}
            />
          </Col>
        </Row>
        <Row>
          <Col className=" col-12 col-lg-6">
            <Form.Group className="mb-3 w-75">
              <Form.Label>جنسیت </Form.Label>
              <Form.Select
                aria-label="Default select example"
                {...register("sex", {
                  required: "جنسیت الزامی است",
                })}
              >
                <option value="" disabled>
                انتخاب کنید...
              </option>
                <option value="1">مرد</option>
                <option value="2">زن</option>
              </Form.Select>
              {errors.sex && (
                <div className="text-danger">{errors.sex.message}</div>
              )}
            </Form.Group>
          </Col>
          <Col className="col-12 col-lg-6">
            <Form.Group className="mb-3 w-75 ">
              <Form.Label>تاریخ تولد</Form.Label>
              <Controller
                control={control}
                className="txt-center"
                name="BirthDay"
                rules={{ required: true }} //optional
                render={({ field }) => (
                  <>
                    <DatePicker
                      className={"date-picker text-center"}
                      {...field}
                      format={"YYYY-MM-DD"}
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-right"
                      defaultValue={"1996-12-02T12:01:39.860Z"}
                    />
                    {errors.BirhDay && <span>تاریخ تولد الزامی است</span>}
                  </>
                )}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col className=" col-12 col-lg-6">
            <DropDownFormat
              control={control}
              label={"استان"}
              options={ProvinceList}
              errors={errors}
              name={"ProvinceId"}
            />
          </Col>
          <Col className=" col-12 col-lg-6">
            <DropDownFormat
              control={control}
              label={"شهر"}
              options={cityList}
              errors={errors}
              name={"CityId"}
            />
          </Col>
        </Row>
        <Row>
          <Col
            className="px-5 col-12 col-lg-12 d-flex gap-2 align-items-center mt-5"
            dir="ltr"
          >
            <Button variant="success" type="submit" className="btn-sm px-4">
              ذخیره
            </Button>
            <Button
              variant="outline-danger"
              onClick={handleLogout}
              className="btn-sm outline text-nowrap"
            >
              خروج
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
